import { LaiSuatText } from "constants/choVayConst";
import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { nFormatter } from "utils/currencyFormat";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { catChuoi } from "utils/stringExtension";
import { BtnDuyetTatToan } from "./ChucNang/BtnDuyetTatToan";
import { BtnSuaTatToan } from "./ChucNang/BtnSuaTatToan";
import { BtnXoaTatToan } from "./ChucNang/BtnXoaTatToan";
import { BtnLichSuTatToan } from "./ChucNang/BtnLichSuTatToan";
import { BtnChiTietHopDongChoVay } from "./ChucNang/BtnChiTietHopDongChoVay";
import { BtnChiTietHopDongNhanVay } from "./ChucNang/BtnChiTietHopDongNhanVay";
import { BtnChiTietKhachHangChoVay } from "./ChucNang/BtnChiTietKhachHangChoVay";
import { BtnChiTietKhachHangNhanVay } from "./ChucNang/BtnChiTietKhachHangNhanVay";
// import { BtnSuaTinChap } from "./ChucNang/Sua/SuaTinChap/BtnSuaTinChap";
// import { BtnSuaCamDo } from "./ChucNang/Sua/SuaCamDo/BtnSuaCamDo";
// import { BtnSuaTinChap } from "./ChucNang/Sua/SuaTinChap/BtnSuaTinChap";
// import BtnSuaTraGop from "./ChucNang/Sua/SuaTraGop/BtnSuaTraGop";
// import { BtnSuaTraGop } from "./ChucNang/Sua/SuaTraGop/BtnSuaTraGop";
// import { BtnXacNhanDuyet } from "./ChucNang/XacNhanDuyet/BtnXacNhanDuyet";
// import { BtnXacNhanGiaoTien } from "./ChucNang/XacNhanGiaoTien/BtnXacNhanGiaoTien";
// import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";

export const ContentTable = ({
  listTatToanChoDuyetFull,
  phanQuyen,
  SearchDanhSach,
}) => {
  const [isModalVisible, setModalVisible] = useState(false);

  return listTatToanChoDuyetFull.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center">{index + 1}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center">
            {item.ChoVayId > 0 && (
              <BtnChiTietHopDongChoVay
                item={item}
                quyenChiTietHopDong={true} /*{quyenChiTietHopDong}*/
              />
            )}
            {item.NhanVayId > 0 && (
              <BtnChiTietHopDongNhanVay item={item}></BtnChiTietHopDongNhanVay>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
        <span className="mobile-column-name">Tên khách hàng</span>
        <div className="center-wrapper">
          <p className="text-left">
            <BtnChiTietKhachHangChoVay
              item={item}
              quyenChiTietKhachHang={true} /*{quyenChiTietKhachHang}*/
            />
            <br />
            {item.Phone}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-8 flex-basis-8-sm">
        <span className="mobile-column-name">Thời gian</span>
        <div className="center-wrapper">
          <p className="text-center">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Tiền tất toán</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span>{formatNumber(item.Value)}</span>
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-7 flex-basis-7-sm">
        <span className="mobile-column-name">Phí khác</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color-do-bold">
              {formatNumber(item.OtherFee)}
            </span>
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-7 flex-basis-7-sm">
        <span className="mobile-column-name">Phí kho</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color-xanh-bold">{formatNumber(item.PhiKho)}</span>
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-7 flex-basis-7-sm">
        <span className="mobile-column-name"> Phí hàng kỳ</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color-cam-bold">
              {formatNumber(item.OtherFeeHangKy)}
            </span>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
        <span className="mobile-column-name">Ghi chú</span>
        <div className="center-wrapper">
          <p className="text-left">
            <span>{item.Note}</span>
          </p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-12 flex-basis-12-sm">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          <p className="text-center">
            {item.BuocDuyet > 0 ? (
              <>
                <span className="buocduyet1">{item.BuocDuyet}</span>
                <span style={{ display: "flex", justifyContent: "center" }}>
                  Chờ &nbsp;{" "}
                  <span className="linkDuyet">{item.TenBuocDuyet}</span>{" "}
                  &nbsp;duyệt
                </span>
              </>
            ) : (
              <>
                <span>{item.TenBuocDuyet}</span>
              </>
            )}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-11-sm action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            <BtnDuyetTatToan
              item={item}
              SearchDanhSach={SearchDanhSach}
            ></BtnDuyetTatToan>
            <BtnLichSuTatToan item={item}></BtnLichSuTatToan>
            {phanQuyen && phanQuyen.tattoanchoduyet_suachoduyet && (
              <BtnSuaTatToan
                item={item}
                SearchDanhSach={SearchDanhSach}
              ></BtnSuaTatToan>
            )}
            {phanQuyen && phanQuyen.tattoanchoduyet_xoachoduyet && (
              <BtnXoaTatToan
                item={item}
                SearchDanhSach={SearchDanhSach}
              ></BtnXoaTatToan>
            )}
          </div>
        </div>
      </div>
    </div>
  ));
};
